import { Component, WritableSignal, ChangeDetectionStrategy } from '@angular/core'
import { ModalComponent } from './modal/modal.component'
import { ModalService } from '../../../services/modal.service'
import { TranslocoDirective } from '@jsverse/transloco'
import { BaseButtonComponent } from '../base/base-button/base-button.component'

export interface TakenOverModalData {
	title: string;
	body: string;
}

/**
 * Shown when the site was opened in another tab, which took over the session (last tab wins). Not closable:
 * this tab stays disconnected until the player chooses to continue here.
 */
@Component({
	selector: 'taken-over-modal',
	imports: [ModalComponent, TranslocoDirective, BaseButtonComponent],
	styles: '',
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<app-modal *transloco="let t" [closable]="false">
			<div modal-title>
				<h2>{{ data()?.title || t('message.info.notification') }}</h2>
			</div>

			<div modal-body>
				<p>{{ data()?.body || t('message.info.openedInAnotherTab') }}</p>
			</div>

			<div modal-footer>
				<base-button variant="primary" (click)="modalService.close('takenOver', true)">
					{{ t('actions.useHere') }}
				</base-button>
			</div>
		</app-modal>
	`
})
export class TakenOverModalComponent {
	public data: WritableSignal<TakenOverModalData | null>

	constructor(public modalService: ModalService) {
		this.data = this.modalService.getData('takenOver')
	}
}
